import { render, staticRenderFns } from "./agendaOS.vue?vue&type=template&id=90098b2a"
import script from "./agendaOS.vue?vue&type=script&lang=js"
export * from "./agendaOS.vue?vue&type=script&lang=js"
import style0 from "./agendaOS.vue?vue&type=style&index=0&id=90098b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports